.chips {
	display: inline-flex;
	align-items: center;
}

/* Overlap the avatars slightly; the ring matches the card surface so the
   overlap reads cleanly on any background. */
.avatar {
	width: 22px;
	height: 22px;
	border-radius: 50%;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-size: 0.6875rem;
	font-weight: 600;
	box-shadow: 0 0 0 2px var(--surface-card);
}

.avatar:not(:first-child) {
	margin-left: -6px;
}

.more {
	margin-left: var(--space-1);
	font-size: 0.75rem;
	color: var(--ink-muted);
}
